import { FaInstagram } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { GoMail } from "react-icons/go";
import { FaMapPin } from "react-icons/fa6";

export default function Contatti() {
    return (
        <div className="pl-12 pr-12 md:pl-32 md:pr-32 xl:pl-72 xl:pr-72 ">
        <div className="grid grid-cols-1 sm:grid sm:grid-cols-2 gap-4">
            <div className="flex flex-col justify-center items-center text-white bg-logo-color2 font-semibold text-base sm:text-lg rounded-xl h-full p-4">
                <h1 className="text-logo-color text-3xl font-bold mb-4">Social</h1>
                <a href="https://www.instagram.com/dot_serramenti?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                    className="flex items-center p-1"><FaInstagram />&nbsp;@dot_serramenti</a>
            </div>

            <div className="flex flex-col justify-center items-center text-white bg-logo-color4 font-semibold text-base sm:text-lg rounded-xl h-full p-4">
                <h1 className="text-logo-color text-3xl font-bold mb-4">Contatti</h1>
                <a href="tel:3934308604" className="flex items-center p-1"><BiPhoneCall />&nbsp;Davide: +39 393 430 8604</a> 
                <a href="tel:3421396350" className="flex items-center p-1"><BiPhoneCall />&nbsp;Matteo: +39 342 139 6350</a>
                <a href="mailto:info@dotserramenti.it" className="flex items-center p-1"><GoMail />&nbsp;Email: info@dotserramenti.it</a>
                
                {/* Indirizzo */}
                
            </div>
                
        </div>
           <div >
              <h1 className="text-logo-color text-3xl font-bold mb-4 pt-8 flex items-center text-center justify-center"><FaMapPin />&nbsp;Via XX Settembre 43, Desio</h1>

                {/* Mappa */}
                <div className="w-full mt-2 rounded-lg overflow-hidden">
                    <iframe
                        title="Mappa sede Dot Serramenti"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3265.5687401242753!2d9.20173567177912!3d45.61972653784833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786bc3ae0ef976b%3A0x2e50452d0c706a07!2sVia%20XX%20Settembre%2C%2043%2C%2020832%20Desio%20MB!5e1!3m2!1sen!2sit!4v1764317524459!5m2!1sen!2sit"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

            </div>

        </div>
        
    );
}
